<template>
  <CFooter :fixed="false">
    
    <div class="ml-auto">
      <span class="mr-1">Powered by</span>
      <a href="https://zedplan.com" target="_blank">
        <CImg src='/img/zedplan.png' alt='Zedplan' class='logo'></CImg>
      </a>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
<style lang="scss" scoped>
.logo{
  max-width: 80px;
}
</style>
